export class Light {
    constructor(objectId: string, name: string, type: LightType, lastComm: Date) {
        this.objectId = objectId;
        this.name = name;
        this.type = type;
        this.lastComm = lastComm;
    }

    objectId: string;//objectId ElementParse
    name: string;
    type: LightType;
    status?: LightStatus;
    level?: number;
    online: boolean = false;
    lastComm: Date;

    public static build(light: Light): Light {
        let l = new Light(light.objectId, light.name, light.type, light.lastComm);
        l.status = light.status;
        l.level = light.level;
        l.online = light.online;
        return l;
    }

}

export enum LightType {
    BINARY,
    RANGE
}

export enum LightStatus {
    OFF,
    ON,
}